import styled from 'styled-components/native';
import { COLORS } from '../../config/designSystem/Colors';
import { FC } from 'react';
import { Feather } from '@expo/vector-icons';

type InfoCardType = 'warn' | 'info' | 'error';
const background: Record<InfoCardType, string> = {
  warn: COLORS.state.warning['inverse-primary'],
  info: COLORS.state.info['inverse-primary'],
  error: COLORS.state.danger['inverse-primary']
};
const text: Record<InfoCardType, string> = {
  warn: COLORS.state.warning.primary,
  info: COLORS.state.info.primary,
  error: COLORS.state.danger.primary
};

const Card = styled.View<{$type: InfoCardType}>`
  background-color: ${({$type}) => background[$type]};
  padding-horizontal: 16px;
  padding-vertical: 24px;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
`;
const Info = styled.Text<{$type: InfoCardType}>`
  color: ${({$type}) => text[$type]};
  flex-shrink: 1;
`;

interface InfoCardProps {
  info: string;
  type: InfoCardType;
}
const InfoCard: FC<InfoCardProps> = ({info, type}) => {
  return (
    <Card $type={type}>
      <Feather
        name={type === 'warn' ? 'alert-triangle' : 'info'}
        size={16}
        color={text[type]}
      />
      <Info $type={type}>{info}</Info>
    </Card>
  );
};
export default InfoCard;
